var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { Suspense } from 'react';
import Grid from '@material-ui/core/Grid';
import { LinearProgress } from '@material-ui/core';
import { checkIsDevEnv, IS_CYPRESS_ENV } from '../utils';
export default function PreloadingComponent(_a) {
    var children = _a.children, style = _a.style, props = __rest(_a, ["children", "style"]);
    var _b = __read(React.useState(true), 2), loading = _b[0], setLoading = _b[1];
    var loadingComponent = (React.createElement(Grid, { container: true, justify: 'center', style: __assign({}, style), "data-id": "izi-line-progress" },
        React.createElement(LinearProgress, { color: "primary", style: { width: '100%' } })));
    if (IS_CYPRESS_ENV) {
        React.useEffect(function () {
            checkIsDevEnv().then(function (res) {
                setLoading(false);
            });
        }, []);
        if (loading) {
            return loadingComponent;
        }
    }
    return React.createElement(Suspense, { fallback: props.withoutLoader ? null : loadingComponent }, children);
}
